export default __webpack_public_path__ + "static/media/noNotification.b6d94b7e.png";